export default __webpack_public_path__ + "static/media/Q_wdt_c_cap_0.b812b835.mp3";